import {LOAD_ALL, LOAD_APPLICATION, RESET_ONE, RESET_ALL} from '../actions/applicationAction'

const initialState = {
	member: '',
	one: null, // Important to be null as it will not work otherwise.
	all: [],
};

const reducer = (state = initialState, action) => {
	var nextState = {};
	switch (action.type) {
		case LOAD_APPLICATION:
			nextState = Object.assign({}, state)
			nextState.one = action.application;

			return nextState
		case LOAD_ALL:
			nextState = Object.assign({}, state)
			nextState.all = action.applications;

			return nextState
		case RESET_ONE:
			// nextState = initialState
			// nextState.all = state.applications;
			nextState = Object.assign({}, state)
			nextState.one = null;

			return nextState
		case RESET_ALL:
			nextState = Object.assign({}, state)
			nextState.all = []

			return nextState
		default:
			return state
	}
};

export default reducer;